import React, { useEffect } from 'react';
import {
    NextArrowIcon,
    QuestionIcon,
    SettingsIcon,
    SupportIcon,
    UnlockIcon
} from '../../svg';
import HowItWorks from './HowItWorks';
import PropertyList from './PropertyList';
import FAQSection from './FAQSection';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

function StepOne({
    setStep,
    propertyData,
    selectedProject,
    setSelectedProject,
    listOtherProperty,
    setListOtherProperty,
    setFurnishType,
    setRentOutTime,
    setExpectedRent,
    setSecurityDeposit,
    setCity,
    setAddress,
    setState,
    resetPin,
    setShowUnregisteredModal
}) {
    const history = useHistory();
    const scrollToSection = (id) => {
        const section = document.getElementById(id);
        if (section) {
            section.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    };

    return (
        <div className="w-[95%] lg:w-[90%] mx-auto ">
            <div
                // style={{
                //     // backgroundImage: `url('https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1748612137677_Rental%20Banner')`,
                //     backgroundImage: `linear-gradient(90deg, rgba(0,0,0,0.4),rgba(0,0,0,0.4)), url('https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1748612137677_Rental%20Banner')`,
                //     backgroundPosition: 'bottom'
                // }}
                className=" w-full bg-primary h-auto lg:h-[570px] mx-auto flex flex-col lg:flex-row justify-center lg:space-x-6 rounded-lg"
            >
                <div className="flex flex-col lg:flex-row justify-center lg:justify-left items-center text-white w-[90%] mx-auto lg:mx-0 mt-10 lg:mt-0 lg:w-[60%] lg:space-x-4 space-y-4">
                    <div className="bg-white bg-opacity-20 rounded-full w-[115px] h-[115px] pt-2">
                        {UnlockIcon}
                    </div>
                    <div className="w-full lg:w-[60%] space-y-6 text-center lg:text-left">
                        <h2 className="text-[20px] lg:text-[30px] font-bold leading-[1.1]">
                            Don’t Let Your Property Sit Idle – Start Earning
                            Now!
                        </h2>
                        <p className="text-[16px] lg:w-[70%]">
                            Transform your vacant space into a profitable
                            rental.
                        </p>
                        <div className="flex justify-center lg:justify-start space-x-3 lg:space-x-6  mx-auto lg:mx-0">
                            <button
                                onClick={() => scrollToSection('Howitworks')}
                                className="flex justify-center items-center bg-white bg-opacity-20 rounded-md px-4 py-2"
                            >
                                {SettingsIcon}{' '}
                                <span className="px-3">How it works</span>{' '}
                                {NextArrowIcon}
                            </button>
                            <button
                                onClick={() => {
                                    window?.webengage?.track('FAQClicked', {});
                                    scrollToSection('Faq');
                                }}
                                className="flex justify-center items-center bg-white bg-opacity-20 rounded-md px-4 py-2"
                            >
                                {QuestionIcon} <span className="px-3">Faq</span>{' '}
                                {NextArrowIcon}
                            </button>
                        </div>
                    </div>
                </div>
                <div className="w-full lg:w-[45%] xl:w-[40%]">
                    <div className="w-[95%] mx-auto lg:mx-0 lg:w-[85%] xl:w-[80%] pt-16 lg:pt-20 mb-36 lg:mb-0">
                        <PropertyList
                            setStep={setStep}
                            propertyData={propertyData}
                            selectedProject={selectedProject}
                            setSelectedProject={setSelectedProject}
                            listOtherProperty={listOtherProperty}
                            setListOtherProperty={setListOtherProperty}
                            setFurnishType={setFurnishType}
                            setRentOutTime={setRentOutTime}
                            setExpectedRent={setExpectedRent}
                            setSecurityDeposit={setSecurityDeposit}
                            setCity={setCity}
                            setAddress={setAddress}
                            setState={setState}
                            resetPin={resetPin}
                            setShowUnregisteredModal={setShowUnregisteredModal}
                        />
                    </div>
                </div>
            </div>

            <div
                className={`w-[95%] lg:w-[60%] mx-auto lg:mx-0  flex justify-center ${
                    propertyData?.length >= 2 ? '-mt-16 lg:-mt-16' : '-mt-16'
                } `}
            >
                <div
                    className={`shadow-lg rounded-md bg-white p-4 lg:px-5 lg:py-8 w-full lg:w-[80%] mx-auto ${
                        propertyData?.length >= 2
                            ? 'lg:mt-0 lg:border-2 lg:border-gray-200'
                            : 'mt-0'
                    } `}
                >
                    <div className="grid grid-cols-6 md:grid-cols-8 gap-x-3 lg:gap-x-4 gap-y-4">
                        <div className="col-span-1 flex justify-center items-center">
                            {SupportIcon}
                        </div>
                        <div className="col-span-5 md:col-span-5 flex flex-col justify-center">
                            <h2 className="text-[16px] md:text-[17px] font-bold pb-1">
                                Need Help to List your Property
                            </h2>
                            <p className="text-[14px]">
                                Give a missed call to{' '}
                                <a
                                    href="tel:08048811281"
                                    className="text-blue-700"
                                >
                                    08048811281
                                </a>{' '}
                                to get help with your property listing.
                            </p>
                        </div>
                        <div className="col-start-2 col-end-4 col-span-2 md:col-span-2 flex flex-col justify-center">
                            <button
                                className=" bg-primary text-white font-semibold px-3 py-2 rounded-md"
                                onClick={() => {
                                    window?.webengage?.track('GetHelpClicked', {
                                        Section: 'Rental'
                                    });
                                    history.push('/contact-us');
                                }}
                            >
                                Get Help
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div
                className={`lg:flex lg:flex-row lg:w-full lg:justify-between ${
                    propertyData?.length > 2 ? 'lg:mt-24 xl:mt-28' : 'lg:mt-8'
                } `}
            >
                <div id="Howitworks" className="lg:w-[50%]">
                    <HowItWorks />
                </div>

                <div id="Faq" className="lg:w-[50%]">
                    <FAQSection />
                </div>
            </div>

            <div className="hidden lg:flex lg:justify-center w-full ">
                <div className="mt-12 bg-[#EDEEF0] rounded-xl py-8 px-6 lg:px-6 flex flex-row items-center justify-between">
                    <div className="grid grid-cols-6 md:grid-cols-8 gap-x-3 lg:gap-x-4 xl:gap-x-8 lg:gap-y-4 xl:gap-y-6">
                        <div className="col-span-1 flex justify-center items-center">
                            {SupportIcon}
                        </div>
                        <div className="col-span-5 md:col-span-5 flex flex-col justify-center -ml-4">
                            <h2 className="text-[16px] md:text-[17px] font-bold pb-1">
                                Need Help to List your Property
                            </h2>
                            <p className="text-[14px]">
                                Give a missed call to{' '}
                                <a
                                    href="tel:08048811281"
                                    className="text-blue-700"
                                >
                                    08048811281
                                </a>{' '}
                                to get help with your property listing.
                            </p>
                        </div>
                        <div className="col-start-2 col-end-4 col-span-2 md:col-span-2 flex flex-col justify-center">
                            <button
                                className=" bg-primary text-white font-semibold px-3 py-2 rounded-md"
                                onClick={() => {
                                    window?.webengage?.track('GetHelpClicked', {
                                        Section: 'Rental'
                                    });
                                    history.push('/contact-us');
                                }}
                            >
                                Get Help
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default StepOne;
